<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('data.payin_details')" :visible.sync="dialogTableVisible" width="700px" class="diglog-card" @open="getDetailInfo">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num"> PHP {{ merchantInfo.transaction_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num">PHP {{ merchantInfo.payment_fee && merchantInfo.payment_fee.fee_split | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payin_created') }}</span>
        <span class="content-blue">{{ $t('data.payin_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <span class="item-left content-blue">{{ $t('data.estimated_settlement_time') }}</span>
        <span class="content-blue">{{ $t('data.actual_settlement_time') }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <div class="item-left" style="color: #4B5567"><span>{{ merchantInfo.estimated_settlement_time || 'N/A' }}</span></div>
        <div class="content-gray"><span>{{ merchantInfo.actual_settlement_time || 'N/A' }}</span></div>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>

      <div v-if="merchantInfo.settlement_status && merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <span class="item-left content-blue">{{ $t('data.settlement_status') }}</span>
        <div class="content-gray"> <span> {{ getTransactionSettlementStatusMap( merchantInfo.settlement_status).label }}</span></div>
      </div>

      <div v-if="[2,3].includes(merchantInfo.pay_product_type)" class="item">
        <span class="item-left content-blue">{{ $t('customerService.payment_code') }}</span>
        <span class="content-gray">{{ merchantInfo.payment_code && merchantInfo.payment_code.payment_code }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.payment_method') }}</span>
        <span class="content-gray">{{ getPayinPaymentMethodMap( merchantInfo.pay_product_type) }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div>

      <!-- QR Stand ID展示 -->
      <div v-show="merchantInfo.qr_stand_no" class="item">
        <span class="item-left content-blue">{{ $t('customerService.qr_stand_id') }}</span>
        <span class="content-gray">{{ merchantInfo.qr_stand_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.app_name') }}</span>
        <span class="content-gray">{{ merchantInfo.app_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.payment_info && merchantInfo.payment_info.payer_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_mobile') }}</span>
        <span class="content-gray">{{ merchantInfo.payment_info && merchantInfo.payment_info.payer_mobile }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.order_amount') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_amount_bill | toDivideWithDot }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.transaction_fee_charge_mode') }}</span>
        <span class="content-gray">{{ merchantInfo.payment_info ? getTansationFeeModeLabel(merchantInfo.payment_info.fee_split_type) : $t('merchant.transaction_fee_charge_mode1') }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.refund_type') }}</span>
        <span class="content-gray">{{ getRefundTypeMap(merchantInfo.refund_category) }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.amount_refunded_successfully') }}</span>
        <span class="content-gray">{{ Math.abs(merchantInfo.total_refunded_amount) | toDivideWithDot }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.remaining_refundable_amount') }}
          <el-tooltip placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.remaining_refundable_amount_tip') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip>
        </span>
        <span class="content-gray">{{ Math.abs(merchantInfo.available_refund_amount) | toDivideWithDot }}</span>
      </div>

      <!-- <el-table-column :label="$t('data.name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_name }}</span>
          </template>
        </el-table-column> -->

      <!-- <el-table-column :label="$t('data.mobile')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_mobile }}</span>
          </template>
        </el-table-column> -->

      <el-tag :type="getPayTransactionStatusType(merchantInfo.transaction_status)" class="payin-status tag-custom"> {{ getPayTransactionStatusMap(merchantInfo.transaction_status) }}</el-tag>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.billing_address') }}</span>
        <span class="content-gray">{{ billingAddress }}</span>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { fetchPayDetail } from '@/api/customer-service/customer-service'
import {
  payTransactionStatusMap,
  payinPaymentMethodMap,
  transactionFeeMode,
  refundStatusMap,
  transactionSettlementStatusMap
} from '@/utils/maps'
export default {
  name: 'Payment_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      success: 2
    }
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    },
    getTansationFeeModeLabel() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    },
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusMap(value).type
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    getTransactionSettlementStatusMap() {
      return function(value) {
        return transactionSettlementStatusMap(value)
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    billingAddress() {
      if (this.merchantInfo?.billing_address) {
        const { address_line1, address_line2, city, province, post_code, country_code } = this.merchantInfo.billing_address
        const str = `${address_line1}, ${address_line2}, ${city}, ${province}, ${post_code}, ${country_code}`
        return str
      } else {
        return '-'
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      fetchPayDetail({ id: this.detailId, sub_merchant_no: this.$route.params.sub_merchant_no }).then(res => {
        if (res.code === 10000) {
          this.merchantInfo = res.data
          if (this.merchantInfo.total_refunded_amount === 0) {
            this.merchantInfo.refund_category = null
          }
        }
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>
.payMentDetails .el-dialog__title {
  font-weight: 600;
  font-size: 16px;
  color: #1B4AEF;
}
.payMentDetails .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>

<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
    flex-shrink: 0;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 160px;
  }
}

</style>
